import React from 'react';
import { motion } from 'framer-motion';
import logo from '../../assets/logo/2685.jpeg';

const Loader = () => {
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white dark:bg-slate-950 transition-colors duration-300">
            <div className="relative">
                {/* Outer Rotating Ring */}
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
                    className="w-24 h-24 rounded-full border-4 border-t-blue-600 border-r-transparent border-b-indigo-500 border-l-transparent shadow-lg"
                />

                {/* Inner Logo */}
                <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: [0.8, 1.1, 1], opacity: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="absolute inset-0 flex items-center justify-center"
                >
                    <div className="w-16 h-16 rounded-full bg-white shadow-inner flex items-center justify-center p-2 overflow-hidden border border-slate-100">
                        <img
                            src={logo}
                            alt="Binary Bulb"
                            className="w-full h-full object-contain"
                        />
                    </div>
                </motion.div>

                {/* Pulsing Glow */}
                <motion.div
                    animate={{
                        scale: [1, 1.2, 1],
                        opacity: [0.3, 0.6, 0.3]
                    }}
                    transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                    className="absolute inset-0 -z-10 bg-blue-500/20 rounded-full blur-xl"
                />
            </div>
        </div>
    );
};

export default Loader;
